/** Сколько тапов по логотипу подряд включают мигание фарами. */
export const LOGO_TAPS_TO_BLINK = 5;
/** Окно, в которое должны уложиться тапы, мс. */
export const LOGO_TAPS_WINDOW_MS = 2000;

/** Добавляет тап и говорит, пора ли мигать; после мигания счёт начинается заново. */
export function registerLogoTap(taps: number[], now: number): { taps: number[]; blink: boolean } {
  const recent = [...taps.filter(t => now - t < LOGO_TAPS_WINDOW_MS), now];
  return recent.length >= LOGO_TAPS_TO_BLINK
    ? { taps: [], blink: true }
    : { taps: recent, blink: false };
}
